import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';

@Component({
  selector: 'app-techquotevendor',
  templateUrl: './techquotevendor.component.html',
  styleUrls: ['./techquotevendor.component.css']
})
export class TechquotevendorComponent implements OnInit {

  stepno: string;
  enquiryData : any;
  enquiryHeader : Enquiryheader;
  isUserAdmin: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,
    private tenderingServices: TenderingService, private userService: UserService,
    private dataSharingService: DataSharingService) {
      this.stepno = this.route.snapshot.params.enquiryid;

      this.userService.isUserAdmin.subscribe(
        value => {
          this.isUserAdmin = value;
          //alert(this.isUserAdmin);
        });
        
     }

  ngOnInit() {
    this.getEnquiryById();
  }

  getEnquiryById() {
    this.tenderingServices.GetEnquiryQuotesById(this.stepno).subscribe(
      data => {
        this.enquiryData = data;
        this.enquiryHeader = this.enquiryData;
        console.log(this.enquiryHeader);
      }
    )
  }

  SubmitTechQuoteForm(form: NgForm) {

    //console.log(form.value);
    form.value.quoteType = "tech";
    
    this.tenderingServices.SubmitTechQuote(form.value).subscribe(
      data => {
        alert("Successfully Submitted");
      }
    );

  }

}
